import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { UserExperienceLevelType } from 'types';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const experienceOptions = [
	{ value: UserExperienceLevelType.FRESHER, label: 'Freshers' },
	{ value: UserExperienceLevelType.FINAL_YEAR_STUDENT, label: 'Final Year Student' },
	{ value: UserExperienceLevelType.OneToTwoYears, label: '1-2 Years' },
	{ value: UserExperienceLevelType.TwoPlusYears, label: '2+ Years' },
];

const ExperienceFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const experience = JSON.parse(searchParams.get('experience') || '[]');

	const options = experienceOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!experience?.length}
					placeholder={'Experience'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: experience?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (experience?.includes(option?.value?.toString())) {
											searchParams.set(
												'experience',
												JSON.stringify(experience?.filter((exp: string) => exp !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('experience', JSON.stringify([...experience, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{experience?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Experience</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Freshers"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => experience?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('experience', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default ExperienceFilterInput;
